import { baseUri, getOptions } from '../utils'
import request from 'api/requestUtils'
import type { GetExploreOffersResponse } from './types'

const endpointUri = `${baseUri}/v2/explore/offers`

export interface ExploreOfferParams {
  bounds: string
  region?: string
  offerTypes?: string
  checkIn?: string
  checkOut?: string
}

export async function getExploreOffers(
  params: ExploreOfferParams,
  accessToken?: string,
): Promise<GetExploreOffersResponse['result']> {
  const queryParams = new URLSearchParams({ bounds: params.bounds })
  if (params.region) {
    queryParams.set('region', params.region)
  }
  if (params.offerTypes) {
    queryParams.set('offerTypes', params.offerTypes)
  }
  if (params.checkIn && params.checkOut) {
    queryParams.set('checkIn', params.checkIn)
    queryParams.set('checkOut', params.checkOut)
  }
  const uri = `${endpointUri}?${queryParams.toString()}`
  return request
    .get<GetExploreOffersResponse>(uri, getOptions(accessToken))
    .then((response) => response.result)
}
